// An element's content width as a signal (#6778): one `ResizeObserver` per element, read
// once on attach so the first paint has a width before the observer's first callback. A
// browser without `ResizeObserver` (the test DOM) keeps the attach-time reading.

import { type Accessor, createSignal, onCleanup } from 'solid-js';

export type ElementWidth = {
  readonly width: Accessor<number>;
  readonly attach: (el: HTMLElement) => void;
};

export function createElementWidth(onChange?: () => void): ElementWidth {
  const [width, setWidth] = createSignal(0);
  let ro: ResizeObserver | undefined;
  onCleanup(() => ro?.disconnect());
  return {
    width,
    attach(el) {
      setWidth(el.clientWidth);
      if (typeof globalThis.ResizeObserver !== 'function') return;
      ro?.disconnect();
      ro = new ResizeObserver((entries) => {
        const w = entries[0]?.contentRect.width;
        if (w === undefined || Math.round(w) === width()) return;
        setWidth(Math.round(w));
        onChange?.();
      });
      ro.observe(el);
    },
  };
}
